import { Flex } from '@mantine/core'
import React from 'react'

export function Body({ children }: React.PropsWithChildren) {
  return (
    <Flex p='md' pt='sm' direction='column' gap={24}>
      {children}
    </Flex>
  )
}
